var map = {
  "./AriaSymptoms/Dash/": "894",
  "./Background/Dash/": "34779",
  "./Behaviour/Dash/": "57164",
  "./Checklist/Dash/": "82551",
  "./Clinicalstudy/Dash/": "16809",
  "./ClpAndCnpTests/Dash/": "18017",
  "./Cognition/Dash/": "559",
  "./Comorbidity/Dash/": "67697",
  "./Dbs/Dash/": "10860",
  "./Diagnosis/Dash/": "4738",
  "./DiagnosticSurvey/Dash/": "80853",
  "./DiagnosticTests/Dash/": "7923",
  "./DietTherapy/Dash/": "61444",
  "./DoctorsOrders/Dash/": "66705",
  "./Examination/Dash/": "92538",
  "./FunctionalPerformance/Dash/": "39354",
  "./FunctionalPerformanceMgravis/Dash/": "61993",
  "./GeneTest/Dash/": "35409",
  "./Generalhealth/Dash/": "30969",
  "./Imaging/Dash/": "38841",
  "./InflammatoryDiseaseActivity/Dash/": "97363",
  "./InterviewSurveys/Dash/": "44329",
  "./Lifestyle/Dash/": "35600",
  "./Medication/Dash/": "64966",
  "./Motor/Dash/": "69566",
  "./MotorFunctionAndMobilityAid/Dash/": "73448",
  "./MotorFunctionHuntington/Dash/": "92894",
  "./MyService/Dash/": "18466",
  "./NeurologicalStatusAndEDSS/Dash/": "57333",
  "./Notes/Dash/": "71226",
  "./Nutrition/Dash/": "98367",
  "./OtherSymptoms/Dash/": "37825",
  "./PatientFiles/Dash/": "36971",
  "./Procedure/Dash/": "29670",
  "./Profile/Dash/": "81461",
  "./Pulmonary/Dash/": "49206",
  "./Relapse/Dash/": "64773",
  "./Rtms/Dash/": "45577",
  "./Seizure/Dash/": "43008",
  "./SurgicalTreatment/Dash/": "76077",
  "./Tdcs/Dash/": "25513",
  "./ThalamotomyHifu/Dash/": "80542",
  "./Therapy/Dash/": "28838",
  "./Treatment/Dash/": "15347",
  "./Updrs/Dash/": "55879",
  "./Vns/Dash/": "73218",
  "./_Boilerplate/Dash/": "62631"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 71594;
